<template>
  <div>
    <BulkOpsHeader
      @new="newDialog = true"
    >
      Case Bulk Import
    </BulkOpsHeader>
    <BulkOpsTable
      :rows.sync="formOps"
      :headers="headers"
      :totalRows="pagination.totalRows"
      :pagination="pagination"
      @fetch="pagination=arguments[0]"
    >
      <template v-slot:default="prop">
        <td>
          <span
            v-if="prop.row.status == 'running'"
          >
            <b>Running...</b>
          </span>
          <span
            v-else
          >
            <b>Imported {{prop.row.count}} Cases</b>
          </span>
          <span
            v-if="prop.row.failed > 0"
            style="color: red;"
          >
            ({{prop.row.failed}} failed!)
          </span>
        </td>
        <td style="text-transform: capitalize;">
          <span
            v-if="prop.row.failed"
          >
            <v-btn
              flat
              color="red"
              small
              @click="getErrorFile(prop.row.id)"
            >
              Download Errors
            </v-btn>
          </span>
        </td>
        <td style="text-transform: capitalize;">
          {{prop.row.status}}
        </td>
      </template>
    </BulkOpsTable>
    <BulkOpsDialog
      v-if="newDialog"
      title="Import Cases"
      :update_actions="bulkOpActions"
      :disabled="cantSubmit"
      @save="save(arguments[0])"
      @cancel="newDialog = false"
    >
      <v-card-text>
        <div style="display:inline-block;width:100%;height:32px;color:lightgrey;font-size:18px;">
          <input
            type="file"
            ref="files"
            accept=".csv"
            v-on:change="handleFileUploads()"
          />
          <v-btn
            flat
            small
            color="primary"
            href="/assets/case_import.csv"
          >
            Download Template CSV
          </v-btn><br />
          <div
            style="color: black;font-size:14px;"
          >
            <b>Importing accepts the following column headers (bold, required): </b><br />
            <b>contact_id, case_number, </b> case_title<br />
            <i>case_number must be unique</i> - a collision will cause the import to fail.
          </div>
        </div>
      </v-card-text>
    </BulkOpsDialog>
  </div>
</template>

<script>
import api from '@/api'
import moment from 'moment'
import GlobalConstants from '@/globals'
import pagination from '@/components/global/pagination'
import BulkOpsHeader from '@/components/admin/bulkops/BulkOpsHeader'
import BulkOpsTable from '@/components/admin/bulkops/BulkOpsTable'
import BulkOpsDialog from '@/components/admin/bulkops/BulkOpsDialog'

export default {
  name: 'CaseImport',
  components: {
    BulkOpsHeader,
    BulkOpsTable,
    BulkOpsDialog
  },
  mixins: [
    pagination
  ],
  data () {
    return {
      formOps: [],
      files: [],
      loading: false,
      pagination: {},
      totalRows: null,
      pages: null,
      newDialog: false,
      interval: null,
      headers: [
        { text: 'Details', width: 180, sortable: false },
        { text: 'Files', width: 60, sortable: false },
        { text: 'Status', width: 60, sortable: false },
        { text: 'Run Time', width: 60, sortable: false },
        { text: 'Progress', width: 60, sortable: false },
      ],
      bulkOpActions: [
      ]
    }
  },
  computed: {
    cantSubmit () {
      return this.files.length == 0
    }
  },
  created () {
    this.documentTitle('Case Import')
  },
  methods: {
    handleFileUploads () {
      this.files = this.$refs.files.files
      if (this.files.length > 0) {
        this.canRun = true
      }
    },
    restartInterval () {
      clearInterval(this.interval)
      var countWorking = 0
      this.formOps.forEach((item) => {
        if (["finished", "failed"].indexOf(item.status) == -1)
          countWorking++
      })
      if (countWorking > 0) {
        this.interval = setInterval(() => {
          this.fetch()
        }, 5000)
      }
    },
    fetch () {
      this.loading = true
      api.bulkops.case_import.list({
        pageNum: this.pagination.page, count: this.pagination.rowsPerPage, ordering: '-created_at', filter: {'case_type__id': this.$route.params.id}
      })
        .then(data => {
          this.formOps = data.results
          this.pagination.totalRows = data.count
          this.pagination.page = data.page_number
          this.loading = false
          this.componentCreated = true
          this.restartInterval()
        })
    },
    save (newOp) {
      let formData = new FormData()
      for( var i = 0; i < this.files.length; i++ ){
        let file = this.files[i]
        formData.append(`import_csv`, file)
      }
      formData.append(`case_type`, this.$route.params.id)
      api.bulkops.case_import.save(formData)
      .then(() => {
        this.newDialog = false
        this.fetch()
      })
    },
    getErrorFile (obj) {
      this.loading = true
      api.bulkops.case_import.downloadFile(obj)
      .then(response => {
        this.loading = false
        let blob = new Blob([response.data])
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = "Case_Import-" + obj + '.csv'
        link.click()
      })
    },
  },
  beforeDestroy () {
    clearInterval(this.interval)
  }
}
</script>
